import './Tooltip.scss';
import clsx from 'clsx';
import React, { memo, PropsWithChildren, ReactNode } from 'react';
import { PlacesType, Tooltip as ReactTooltip } from 'react-tooltip';

type Props = PropsWithChildren<{
  id: string;
  place?: PlacesType;
  value: ReactNode;
  customRef?: (node: HTMLElement | null) => void;
  disabled?: boolean;
}>;

export const Tooltip = memo(({ id, place, value, customRef, disabled, children }: Props) => (
  <div ref={customRef} className="bp-tooltip">
    <div
      className={clsx({
        'bp-tooltip__target': true,
        'bp-tooltip__target--disabled': disabled,
      })}
      data-tooltip-id={id}
    >
      {children}
    </div>

    <ReactTooltip
      id={id}
      clickable={true}
      place={place}
      hidden={disabled}
      className="bp-tooltip__content"
    >
      {value}
    </ReactTooltip>
  </div>
));
